export default "__VITE_ASSET__CoPQB$$W__"